/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Showalldates2Inputs */

const en_showalldates2 = /** @type {(inputs: Showalldates2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Show all ${i?.count} dates`)
};

const de_showalldates2 = /** @type {(inputs: Showalldates2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle ${i?.count} Termine anzeigen`)
};

/**
* | output |
* | --- |
* | "Show all {count} dates" |
*
* @param {Showalldates2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const showalldates2 = /** @type {((inputs: Showalldates2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Showalldates2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_showalldates2(inputs)
	return de_showalldates2(inputs)
});
export { showalldates2 as "showAllDates" }